import { Component, EventListener, triggerPublicEvent, getComponentByDomNode } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { getCurrentViewport, VIEWPORT_ENTERED } from '@gondel/plugin-media-queries';
import { Overlay } from '../../../organisms/overlay/js/overlay';

import { IStyledSelectApi } from './initDropKick';

enum States {
	Open = 'state-a-select--open',
	Focus = 'state-a-select--focus',
	Default = 'state-a-select--default',
}

enum Selectors {
	Select = '.js-a-select__input',
	SelectOption = '.js-a-select__input-option',
	Overlay = '.js-o-page__overlay',
}

@Component('Select')
export class Select extends GondelJqueryComponent {
	private isInOverlay: boolean = false;
	private overlay: Overlay;
	private pluginInstance: IStyledSelectApi;

	public start() {
		const $overlay = this.$ctx.closest(Selectors.Overlay);
		if ($overlay.length > 0) {
			this.overlay = getComponentByDomNode<Overlay>($overlay.get(0));
			this.isInOverlay = true;
		}
	}

	public async sync() {
		// tslint:disable-next-line
		const asyncModule = await import(/* webpackChunkName: "dynamic-imports/dropkick" */ './initDropKick');

		this.pluginInstance = asyncModule.initialize(
			$(Selectors.Select, this.$ctx),
			this.handleDropDownOpen,
			this.handleDropDownClose,
			this.handleDropDownChange
		);
		// event-source is select-option because class gets copied onto styled dropdown
		$(Selectors.SelectOption, this.$ctx).one('focus', () => triggerPublicEvent('gFormInteractionEvent', this));
	}

	@EventListener(VIEWPORT_ENTERED)
	public _handleViewportChangeEvent() {
		// close select to not need to maintain page / overlay scroll states
		this.pluginInstance.close();
	}

	@EventListener('focus')
	public _handleFocusEvent() {
		this.$ctx.addClass(States.Focus);
	}

	@EventListener('blur')
	public _handleBlurEvent() {
		this.$ctx.removeClass(States.Focus);
	}

	private handleDropDownOpen = () => {
		this.$ctx.addClass(States.Open);
		this.setScrollState(false);
	};

	private handleDropDownClose = () => {
		this.$ctx.removeClass(States.Open);
		this.setScrollState(true);
	};

	private handleDropDownChange = () => {
		this.$ctx.removeClass(States.Default);
	};

	private setScrollState(newState: boolean) {
		const currentVp = getCurrentViewport();

		if (currentVp === 'small' || currentVp === 'xsmall' || currentVp === 'xxsmall') {
			if (this.isInOverlay) {
				this.overlay.setScrolling(newState);
			} else {
				triggerPublicEvent('gScrollHandler', this, undefined, {
					scroll: newState,
				});
			}
		}
	}
}
